"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Submenu = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _getContrastingTextColor = require("../../utils/getContrastingTextColor");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var styles = function styles(theme) {
  var activeBorderWidthPx = 4;
  var itemHeight = 32;
  var activeSubmenuItemColor = (0, _getContrastingTextColor.getContrastingTextColorHexString)(theme.colors.primary, undefined, undefined, _getContrastingTextColor.PRIMARY_CONTRAST_STANDARD);
  return {
    submenu: {
      cursor: "pointer",
      color: theme.colors.baseContrast080,
      userSelect: "none",
      margin: 0
    },
    mainItem: {
      height: itemHeight,
      fontSize: theme.typography.fontSize + 2,
      fontWeight: 700,
      // eslint-disable-next-line @atg/css-rtl-support
      paddingLeft: theme.spacing.base * 3,
      // eslint-disable-next-line @atg/css-rtl-support
      paddingRight: theme.spacing.base * 1.5,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      "&:hover": {
        background: theme.colors.baseContrast020,
        color: theme.colors.baseContrast090
      }
    },
    active: {},
    activeMainItem: {
      borderLeft: {
        color: theme.colors.primary,
        width: activeBorderWidthPx,
        style: "solid"
      },
      // eslint-disable-next-line @atg/css-rtl-support
      paddingLeft: theme.spacing.base * 3 - activeBorderWidthPx
    },
    disabledMainItem: {
      color: theme.colors.baseContrast030,
      cursor: "not-allowed",
      "&:hover": {
        color: theme.colors.baseContrast030,
        background: "initial"
      }
    },
    indicator: {
      // eslint-disable-next-line @atg/css-rtl-support
      marginRight: 2,
      transition: "transform 0.3s"
    },
    activeIndicator: {
      transform: "rotate(90deg)"
    },
    subItem: {
      fontSize: 14,
      display: "flex",
      alignItems: "center",
      lineHeight: "".concat(theme.spacing.base * 2.5, "px"),
      "&:hover": {
        background: theme.colors.baseContrast020,
        color: theme.colors.baseContrast090
      }
    },
    subItemPadding: {
      padding: [theme.spacing.base, theme.spacing.base * 4]
    },
    subItemCustom: {
      "& > *": {
        width: "100%",
        padding: [theme.spacing.base, theme.spacing.base * 4]
      }
    },
    activeSubmenuItem: {
      composes: ["$active"],
      "&, & a": {
        background: theme.colors.primary,
        color: activeSubmenuItemColor,
        "&:hover": {
          background: theme.colors.primary,
          color: activeSubmenuItemColor
        }
      }
    },
    disabledSubmenuItem: {
      color: theme.colors.baseContrast030,
      cursor: "not-allowed",
      "&:hover": {
        color: theme.colors.baseContrast030,
        background: "initial"
      }
    },
    open: {
      opacity: 1,
      transition: "height 0.5s ease, opacity 1s ease",
      overflow: "hidden"
    },
    closed: {
      opacity: 0,
      height: "0 !important",
      transition: "height 0.5s ease, opacity 0.25s ease",
      pointerEvents: "none",
      overflow: "hidden"
    },
    link: {
      width: "100%",
      color: "unset"
    },
    menuItemLink: {
      composes: ["$link", "$mainItem"],
      justifyContent: "initial"
    },
    submenuItemLink: {
      composes: ["$link", "$subItem", "$subItemPadding"]
    },
    labelIcon: {
      marginInlineEnd: theme.spacing.base
    }
  };
};
var useStyles = (0, _createUseStyles.default)(styles, {
  name: "SideMenuSubmenu"
});
var Label = function Label(props) {
  var classes = useStyles();
  var icon = props.icon && /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    name: props.icon,
    size: "small",
    className: classes.labelIcon
  });
  if (props.href) {
    var target = props.externalLink ? {
      target: "_blank",
      rel: "noreferrer"
    } : {};
    return /*#__PURE__*/_react.default.createElement("a", _extends({
      className: props.linkClasses,
      href: props.href
    }, target), icon, props.label);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, icon, props.label);
};
Label.displayName = "Label";
var Submenu = exports.Submenu = function Submenu(_ref) {
  var _menuItem$submenus, _menuItem$submenus2, _menuItem$submenus3;
  var activeKey = _ref.activeKey,
    setActiveItem = _ref.setActiveItem,
    _ref$defaultOpen = _ref.defaultOpen,
    defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen,
    onItemClick = _ref.onItemClick,
    menuItem = _ref.menuItem,
    render = _ref.render;
  var classes = useStyles();
  var _useState = (0, _react.useState)(defaultOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var submenuRef = (0, _react.useRef)(null);
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    submenuHeight = _useState4[0],
    setSubmenuHeight = _useState4[1];
  var hasSubmenu = ((_menuItem$submenus = menuItem.submenus) === null || _menuItem$submenus === void 0 ? void 0 : _menuItem$submenus.length) > 0;
  var onMainClick = function onMainClick() {
    if (menuItem.isDisabled) {
      return;
    }
    if (hasSubmenu) {
      setIsOpen(!isOpen);
    } else {
      setActiveItem(menuItem.key);
    }
    if (typeof menuItem.onClick === "function") {
      menuItem.onClick();
    }
    if (typeof onItemClick === "function") {
      onItemClick({
        key: menuItem.key,
        isOpen: isOpen,
        isClickable: !hasSubmenu
      });
    }
  };
  var isActive = activeKey === menuItem.key || ((_menuItem$submenus2 = menuItem.submenus) === null || _menuItem$submenus2 === void 0 ? void 0 : _menuItem$submenus2.some(function (item) {
    return item.key === activeKey;
  }));

  /**
   * Priorities:
   * 1. custom render function for this item
   * 2. global renderer (if there are no children, because in that case this is just a box that opens and closes)
   * 3. text label
   */
  var renderItem = menuItem.render || !hasSubmenu && render || Label;
  (0, _react.useEffect)(function () {
    setIsOpen(defaultOpen);
  }, [defaultOpen]);
  (0, _react.useEffect)(function () {
    setSubmenuHeight(submenuRef.current.scrollHeight);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.submenu
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, classes.mainItem, !menuItem.href), classes.active, activeKey === menuItem.key && !menuItem.href), classes.activeMainItem, isActive && !menuItem.href), classes.disabledMainItem, menuItem.isDisabled)),
    onClick: onMainClick
  }, renderItem({
    key: menuItem.key,
    label: menuItem.label,
    isDisabled: menuItem.isDisabled,
    data: menuItem.data,
    href: menuItem.href,
    linkClasses: menuItem.href && classes.menuItemLink,
    icon: menuItem.icon,
    externalLink: menuItem.externalLink
  }), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      flex: 1
    }
  }), hasSubmenu && /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    name: "chevronRight",
    className: (0, _classnames.default)(classes.indicator, _defineProperty({}, classes.activeIndicator, isOpen))
  })), /*#__PURE__*/_react.default.createElement("div", {
    ref: submenuRef,
    className: (0, _classnames.default)(_defineProperty(_defineProperty({}, classes.open, isOpen), classes.closed, !isOpen)),
    style: submenuHeight ? {
      height: submenuHeight
    } : {}
  }, (_menuItem$submenus3 = menuItem.submenus) === null || _menuItem$submenus3 === void 0 ? void 0 : _menuItem$submenus3.map(function (submenuItem) {
    var renderItem = submenuItem.render || render || Label;
    var customSubItem = renderItem === render;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(classes.subItem, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, classes.subItemPadding, !customSubItem && !submenuItem.href), classes.subItemCustom, customSubItem), classes.activeSubmenuItem, submenuItem.key === activeKey && !submenuItem.href), classes.disabledSubmenuItem, submenuItem.isDisabled)),
      key: submenuItem.key,
      onClick: function onClick() {
        if (submenuItem.isDisabled) {
          return;
        }
        setActiveItem(submenuItem.key);
        if (typeof submenuItem.onClick === "function") {
          submenuItem.onClick();
        }
        if (typeof onItemClick === "function") {
          onItemClick({
            key: submenuItem.key,
            isClickable: true
          });
        }
      }
    }, renderItem({
      key: submenuItem.key,
      label: submenuItem.label,
      isDisabled: submenuItem.isDisabled,
      data: submenuItem.data,
      href: submenuItem.href,
      linkClasses: submenuItem.href && classes.submenuItemLink,
      icon: submenuItem.icon,
      externalLink: submenuItem.externalLink
    }));
  })));
};
Submenu.displayName = "Submenu";